import TwoFactorService from '../infrastructure/twoFactorService.js'
import showTwoFactorPrompt from '../presentation/showTwoFactorPrompt.js'

/**
 * Gère l'étape d'authentification à double facteur (2FA) lors de la connexion
 * @param {object} context - Context auth (events, sendBugAlert, etc.)
 * @param {object} user - Instance de l'utilisateur connecté
 * @returns {Promise<{ success: boolean, cancelled?: boolean }>}
 */
export async function handleTwoFactorAuth(context, user) {
  const userId = user?.id || (typeof user?.getId === 'function' ? user.getId() : '')
  if (!userId) {
    console.error('handleTwoFactorAuth: ID utilisateur manquant', user)
    return { success: false, error: 'USER_ID_MISSING' }
  }

  // 1. Vérifier si le 2FA est activé
  const statusRes = await TwoFactorService.checkStatus(userId)
  const isEnabled = !!statusRes.isEnabled

  if (!isEnabled) {
    // 2. Cas non activé : Initialiser la configuration 2FA (QR code + clé secrète)
    const enableRes = await TwoFactorService.enable(userId)
    if (!enableRes.success) {
      console.warn('Impossible de générer la configuration 2FA:', enableRes.error)
      // Si la génération échoue, on affiche quand même la modale de configuration avec saisie du code bypass
    }

    const promptRes = await showTwoFactorPrompt({
      isSetup: true,
      qrUrl: enableRes.qrUrl || '',
      secretKey: enableRes.secretKey || '',
      onVerify: async secretotp => {
        return await TwoFactorService.confirm(userId, secretotp)
      },
    })

    return promptRes
  }

  // 3. Cas activé : Demander simplement le code TOTP
  const promptRes = await showTwoFactorPrompt({
    isSetup: false,
    onVerify: async secretotp => {
      return await TwoFactorService.verify(userId, secretotp)
    },
  })

  return promptRes
}

export default handleTwoFactorAuth
